import * as React from 'react';
import Button from 'components/src/button';
import { handleSendSMS, SMSResponseState } from './Utils';
import { Check } from 'components/src/svg';
import { colors } from 'components/src/foundation';
import { Subheading } from 'components/src/typography';

type Props = {
  phoneNumber: string;
  companyName: string;
  saleInfo: string;
  codeQuantity?: number;
  messageText?: string;
  providerCode?: string;
  state: SMSResponseState | null;
  setState: React.Dispatch<React.SetStateAction<SMSResponseState | null>>;
};

const SuccessState = () => {
  return (
    <div className="flex h-56 min-w-[62px] flex-col items-center justify-center gap-8 self-stretch rounded-full bg-[#006619]">
      <div className="py-10 flex items-center justify-center gap-sm self-stretch sm:px-lg">
        <Check color={colors.primary.white} size={18} />
        <div className="flex flex-col items-start justify-center gap-[2px] p-0 text-[#FEF4F5]">
          <p className="label-lg">Tilboð virkjað</p>
          <p className="text-center text-[11px] leading-[18px] tracking-wide">Skilaboð hafa verið send í símann þinn</p>
        </div>
      </div>
    </div>
  );
};

const DefaultState = ({
  phoneNumber,
  companyName,
  codeQuantity,
  messageText,
  providerCode,
  saleInfo,
  setState,
}: {
  phoneNumber: string;
  companyName: string;
  codeQuantity?: number;
  messageText?: string;
  providerCode?: string;
  saleInfo: string;
  setState: React.Dispatch<React.SetStateAction<SMSResponseState | null>>;
}) => {
  const [loading, setLoading] = React.useState(false);

  return (
    <Button
      label={'Senda'}
      variant="primary"
      autoWidth={false}
      loading={loading}
      onClick={() => {
        handleSendSMS(
          phoneNumber,
          companyName,
          saleInfo,
          setState,
          setLoading,
          codeQuantity,
          messageText,
          providerCode
        );
      }}
      disabled={phoneNumber.length <= 6}
    />
  );
};

const ErrorState = () => {
  return (
    <Subheading small classes="text-red-100">
      {'Náði ekki að senda skilaboð, reyndu aftur síðar.'}
    </Subheading>
  );
};

const OfferUsedState = () => {
  return (
    <Subheading small classes="text-black-50">
      {'Þú hefur þegar notað þetta tilboð.'}
      <br></br>
      {'Þú getur reynt aftur síðar.'}
    </Subheading>
  );
};

const NotAllowedState = () => {
  return (
    <Subheading small classes="text-black-50">
      {'Þetta númer getur ekki nýtt sér tilboð.'}
    </Subheading>
  );
};

const FooterSection = ({
  phoneNumber,
  companyName,
  codeQuantity,
  messageText,
  saleInfo,
  providerCode,
  state,
  setState,
}: Props) => {
  if (state === 'success') {
    return <SuccessState />;
  } else if (state === 'offerUsed') {
    return <OfferUsedState />;
  } else if (state === 'userNotAllowed') {
    return <NotAllowedState />;
  } else if (state === 'error' || state === 'unknown') {
    return <ErrorState />;
  }
  return (
    <DefaultState
      phoneNumber={phoneNumber}
      companyName={companyName}
      codeQuantity={codeQuantity}
      messageText={messageText}
      providerCode={providerCode}
      saleInfo={saleInfo}
      setState={setState}
    />
  );
};
export default FooterSection;
